import React, { useMemo } from 'react';
import classNames from 'classnames';
import { formatNumber } from '../utils';
import { Typography } from '../../../Typography';
import "./styles.css";
export var BadgeContent = function (_a) {
    var count = _a.count, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.warning, warning = _c === void 0 ? false : _c, _d = _a.hideBadgeContent, hideBadgeContent = _d === void 0 ? false : _d;
    var badgeContent = useMemo(function () { return formatNumber(count); }, [count]);
    return (React.createElement(Typography, { className: classNames('lk-ui_badge', error && 'lk-ui_badge__error', warning && 'lk-ui_badge__exclamation'), variant: 'overline' }, !hideBadgeContent && (warning ? '!' : badgeContent)));
};
